import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';

import { BaseComponents } from '../base.component';

@Injectable()
export class BsInquiryCoverageMotorMappingV2Service extends BaseComponents{
  constructor(
    protected injectorObj: Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService, 
    //private logger: NGXLogger
    ) {
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if(this.VERIFY_TOKEN_EXPIRE){
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any) {
    const url = `${environment.endpointBackend}/api/bsInquiryCoverageMotorMappingV2`;
    const body = this.input(param);
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec(param: any) {
    const self = this;
    return new Promise(function(resolve, reject) {
      if(!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()){
        self.connector(param).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            let datas = self.output(res['body'])
            datas.data = datas.data.sort(self.compare);
            resolve(datas);
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus:  401,
          message: 'token is expired'
        });
      }
    });
  }

  
  compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const secureA = a.brandID;
    const secureB = b.brandID;

    let comparison = 0;
    if (secureA > secureB) {
      comparison = 1;
    } else if (secureA < secureB) {
      comparison = -1;
    }
    //console.log(comparison)
    return comparison;
  }
}
